import React, { useState } from "react";
import { ValueContainerProps, ValueType } from "react-select";
import Select from "react-select";

type LanguageDropdownProps = {
  value: any;
  options: { label: string; value: any; data?: any }[];
  onChange: (selectedOption: ValueType<any, false>) => void; // ValueType<SelectOption, false> - false means isMulti = false
  label?: string;
};

const ValueContainer = ({
  children,
  ...props
}: ValueContainerProps<any, false>) => {
  // ValueType<SelectOption, false> - false means isMulti = false
  const selectProps = props.selectProps;

  const value = selectProps.value;

  let valueData = selectProps.options
    ? selectProps.options.filter(item => item.value === value.value)
    : null;

  let valueImage = null;

  if (
    valueData &&
    Array.isArray(valueData) &&
    valueData.length > 0 &&
    valueData[0] &&
    typeof valueData[0] === "object" &&
    valueData[0].data &&
    valueData[0].data.image
  ) {
    valueImage = valueData[0].data.image;
  }

  return (
    <div
      className={`CustomValueContainer 
`}
    >
      {valueImage && <img src={valueImage} alt="image" className="Image" />}

      {children}
    </div>
  );
};

const Option: React.FC<any> = props => {
  const { innerProps, innerRef, ...rest } = props;
  const data = props.data;

  return (
    <div
      className={`CustomOption ${props.isSelected ? "Selected" : ""}`}
      ref={innerRef}
      {...innerProps}
    >
      {data.data && data.data.image && (
        <img src={data.data.image} alt="language icon" className="Image" />
      )}
      <div className="Label">{data.label}</div>
    </div>
  );
};

const LanguageDropdown: React.FC<LanguageDropdownProps> = ({
  value,
  options,
  onChange,
  label,
}) => {
  const [menuOpen, setMenuOpen] = useState<boolean>(false);

  return (
    <div className="LanguageDropdown">
      {options && Array.isArray(options) && (
        <div className="SettingsOption">
          {label && <div className="Label">{label}</div>}

          <Select
            className="CustomSelect"
            classNamePrefix="CustomSelect"
            options={options}
            value={value}
            onChange={onChange}
            menuPlacement="auto"
            components={{ Option: Option, ValueContainer: ValueContainer }}
            menuIsOpen={menuOpen}
            onMenuOpen={() => {
              setMenuOpen(true); // NOTE: This is needed to make click on mobile phones work
            }}
            onMenuClose={() => {
              setMenuOpen(false); // NOTE: This is needed to make click on mobile phones work
            }}
          />
        </div>
      )}
    </div>
  );
};

export default LanguageDropdown;
